import { Component, ViewChild } from '@angular/core';
import { ApiService } from '../services/api.service';
import { languageSettings } from '../lenguajeDatatable';
import { faPencilAlt, faPlus, faSync } from '@fortawesome/free-solid-svg-icons';
import { PlanModalComponent } from '../plan-modal/plan-modal.component';
import { ToastService } from '../services/toast.service';
import { LoadingService } from '../services/loading.service';
import $ from 'jquery';
import 'datatables.net-responsive-bs5';

@Component({
  selector: 'app-plan',
  templateUrl: './plan.component.html',
  styleUrls: ['./plan.component.css'],
})
export class PlanComponent {
  @ViewChild(PlanModalComponent) planModalComponent!: PlanModalComponent;
  faPencil = faPencilAlt;
  faPlus = faPlus;
  faSync = faSync;
  planes: any[] = [];
  salarioMVM: number = 0;
  editandoSalario: boolean = false;
  salarioTemporal: number = 0;

  constructor(
    private apiSrv: ApiService,
    private toastSrv: ToastService,
    private loadingSrv: LoadingService
  ) {}

  ngOnInit(): void {
    this.obtenerPlanes();
    this.obtenerSalarioMVM();
  }

  private obtenerPlanes(): void {
    this.loadingSrv.setLoading(true);
    this.apiSrv.obtenerPlanes().subscribe({
      next: (data: any[]) => {
        const tabla = $('#tablaPlanes').DataTable();
        tabla.clear().destroy();
        this.planes = data;
        this.inicializarDataTable();
        this.loadingSrv.setLoading(false);
      },
      error: (error) => {
        this.toastSrv.mostrarNotificacion(
          'Error al obtener los planes: ' +
            (error ? JSON.stringify(error) : 'Error desconocido'),
          'error'
        );
        this.loadingSrv.setLoading(false);
      },
    });
  }

  private obtenerSalarioMVM(): void {
    this.loadingSrv.setLoading(true);
    this.apiSrv.obtenerSalarioMVM().subscribe({
      next: (data: number) => {
        this.salarioMVM = data;
        this.loadingSrv.setLoading(false);
      },
      error: (error) => {
        this.toastSrv.mostrarNotificacion(
          'Error al obtener Salario MVM: ' +
            (error ? JSON.stringify(error) : 'Error desconocido'),
          'error'
        );
        this.loadingSrv.setLoading(false);
      },
    });
  }

  inicializarDataTable(): void {
    const tableBody = this.planes.map((row) => [
      row.descripcion,
      row.importeDesde,
      row.importeHasta,
      row.activo === true ? 'Activo' : 'Inactivo',
      this.formatearFecha(row.fechaUltimaActualizacion),
      `<button class="btn-editar btn btn-link p-0 d-flex align-items-center" id="editarPlan"
      data-id="${row.id}"
      data-descripcion="${row.descripcion}"
      data-importedesde="${row.importeDesde}"
      data-importehasta="${row.importeHasta}"
      data-activo="${row.activo}">
      <span>Editar</span>
      <i class="fas fa-pencil-alt ms-2"></i>
    </button>`,
    ]);

    $('#tablaPlanes').DataTable({
      data: tableBody,
      language: languageSettings,
      columns: [
        { title: 'Descripción' },
        {
          title: 'Importe Desde',
          render: $.fn.dataTable.render.number('.', ',', 2, ''),
        },
        {
          title: 'Importe Hasta',
          render: $.fn.dataTable.render.number('.', ',', 2, ''),
        },
        { title: 'Activo' },
        { title: 'Ult. Actualización' },
        { title: 'Acciones' },
      ],
    });
  }

  private formatearFecha(fecha: string): string {
    const [year, month, day] = fecha.split('-');
    return `${day}/${month}/${year}`;
  }

  ngAfterViewInit(): void {
    $(document).on('click', '.btn-editar', (event) => {
      const button = $(event.currentTarget);
      const plan = {
        id: button.data('id'),
        descripcion: button.data('descripcion'),
        importeDesde: button.data('importedesde'),
        importeHasta: button.data('importehasta'),
        activo: button.data('activo'),
      };
      this.editarPlan(plan);
    });
  }

  editarPlan(plan: any): void {
    this.eliminarModalBackdrop();
    this.planModalComponent.abrirModoEdicionPlan(plan);
  }

  editarSalarioMVM(): void {
    this.editandoSalario = true;
    this.salarioTemporal = this.salarioMVM;
  }

  guardarSalarioMVM(): void {
    this.salarioMVM = this.salarioTemporal;
    this.editandoSalario = false;
    this.loadingSrv.setLoading(true);
    this.apiSrv.guardarSalioMVM(this.salarioMVM.toString()).subscribe({
      next: () => {
        this.toastSrv.mostrarNotificacion(
          'Salario MVM actualizado correctamente',
          'success'
        );
        this.loadingSrv.setLoading(false);
      },
      error: (error) => {
        this.toastSrv.mostrarNotificacion(
          'Error al guardar Salario MVM: ' +
            (error ? JSON.stringify(error) : 'Error desconocido'),
          'error'
        );
        this.loadingSrv.setLoading(false);
      },
    });
  }

  cancelarEdicion(): void {
    this.editandoSalario = false;
    this.salarioTemporal = this.salarioMVM;
  }

  recargarTabla(): void {
    this.obtenerPlanes();
  }

  abrirModoCreacionPlan(): void {
    this.eliminarModalBackdrop();
    this.planModalComponent.abrirModoCreacionPlan();
  }

  eliminarModalBackdrop(): void {
    const backdrops = document.querySelectorAll('.modal-backdrop');
    backdrops.forEach((backdrop) => {
      backdrop.parentNode?.removeChild(backdrop);
    });
  }

  reasignarPlanes(): void {
    this.loadingSrv.setLoading(true);
    this.apiSrv.reasignarPlanes().subscribe({
      next: (response) => {
        this.toastSrv.mostrarNotificacion(
          'Planes reasignados exitosamente',
          'success'
        );
        this.loadingSrv.setLoading(false);
      },
      error: (error) => {
        this.toastSrv.mostrarNotificacion(
          'Error al reasignar planes. ' + (error ? error.error?.message : ''),
          'error'
        );
        this.loadingSrv.setLoading(false);
      },
    });
  }
}
